import React from "react";
import VehicleBrandActionDropdown from "./VehicleBrandActionDropdown";
import config from "../../Data/AuthUser";

const VehicleBrandTableRow = ({
  row,
  headers,
  rowKey,
  isDropdownOpen,
  toggleDropdown,
  onActionClick,
  rowIndex,
  rowClassName,
  tableStyle,
}) => {
  const renderCellContent = (key, value, row) => {
    if (key === "logoDisplay") {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {row.logo ? (
            <img
              src={config.apiImageUrl + row.logo}
              alt="Logo"
              style={{
                width: 50,
                height: 50,
                borderRadius: "50%",
                objectFit: "cover",
              }}
            />
          ) : (
            <div
              style={{
                width: 50,
                height: 50,
                borderRadius: "50%",
                backgroundColor: "#f0f0f0",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "10px",
                color: "#666",
              }}
            >
              No Logo
            </div>
          )}
        </div>
      );
    }
    return value;
  };

  return (
    <tr
      className={`${
        rowIndex % 2 === 0 ? "bg-white" : "bg-white"
      } border-b border-gray-200 ${rowClassName}`}
    >
      {headers.map(({ key }, headerIdx) => (
        <td key={key} className="py-2 px-4" style={tableStyle}>
          {renderCellContent(key, row[key], row)}
        </td>
      ))}
      <td className="py-2 px-4 text-start relative" style={tableStyle}>
        <button
          className="text-gray-500 hover:text-gray-700"
          onClick={(e) => {
            e.stopPropagation();
            toggleDropdown(rowIndex);
          }}
          aria-label="Open actions menu"
        >
          <i className="fas fa-ellipsis-h"></i>
        </button>
        <VehicleBrandActionDropdown
          isOpen={isDropdownOpen}
          row={row}
          headers={headers}
          onActionClick={onActionClick}
          onClose={() => toggleDropdown(null)}
        />
      </td>
    </tr>
  );
};

export default VehicleBrandTableRow;
